import { render, staticRenderFns } from "./areaChart.vue?vue&type=template&id=09e52d73&scoped=true&"
import script from "./areaChart.vue?vue&type=script&lang=js&"
export * from "./areaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e52d73",
  null
  
)

export default component.exports